import * as UIActions from './ui.actions';
import { IAppState } from '../../store/app.state';
import { Action, createReducer, createSelector, on } from '@ngrx/store';
import { LeftPanel, MainPanel, RightPanel, UIModel } from '../models/ui.model';

export type State = UIModel;

const initialState: State = {
  overview: {
    leftPanel: LeftPanel.FILES,
    mainPanel: MainPanel.TABLE,
    rightPanel: RightPanel.NONE
  },
  zoom: 100
};

const customerReducer = createReducer(
  initialState,
  on(UIActions.ZoomIn, (state): State => {
    return {
      ...state,
      zoom: changeZoom(state.zoom, 1)
    };
  }),

  on(UIActions.ZoomOut, (state): State => {
    return {
      ...state,
      zoom: changeZoom(state.zoom, -1)
    };
  }),

  on(UIActions.ZoomReset, (state): State => {
    return {
      ...state,
      zoom: 100
    };
  }),

  on(UIActions.SetRightPanel, (state, { rightPanel }): State => {
    return {
      ...state,
      overview: {
        ...state.overview,
        rightPanel
      }
    };
  }),

  on(UIActions.SetMainPanel, (state, { mainPanel }): State => {
    return {
      ...state,
      overview: {
        ...state.overview,
        mainPanel
      }
    };
  }),

  on(UIActions.SetLeftPanel, (state, { leftPanel }): State => {
    return {
      ...state,
      overview: {
        ...state.overview,
        leftPanel
      }
    };
  })
);

export const reducer = (state: State, action: Action): State => customerReducer(state, action);

export const uiState = (state: IAppState) => state.ui;

export const getZoom = createSelector(uiState, (state: UIModel) => state.zoom);

export const getRightPanel = createSelector(uiState, (state: UIModel) => state.overview.rightPanel);
export const getMainPanel = createSelector(uiState, (state: UIModel) => state.overview.mainPanel);
export const getLeftPanel = createSelector(uiState, (state: UIModel) => state.overview.leftPanel);

const changeZoom = (zoom: number, inc: 1 | -1) => {
  const multiplier = 10;
  const minZoom = 50;
  const maxZoom = 200;
  const newZoom = zoom + multiplier * inc;
  return Math.min(Math.max(newZoom, minZoom), maxZoom);
};
